import {
    HttpInterceptor,
    HttpHandler,
    HttpRequest,
    HttpEvent,
    HttpResponse,
    HttpErrorResponse,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { tap, catchError } from 'rxjs/operators';
import { CredentialsApiService } from '@services/api-calls/credentials-api.service';

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
    constructor(
        private credentials_service: CredentialsApiService,
        private router: Router
    ) {}

    handleError(error: HttpErrorResponse) {
        if (error.status == 401 && this.router.url !== '/login') {
            this.credentials_service.refreshToken().subscribe(
                (response) => {
                    location.reload();
                },
                (error) => {
                    console.log(error);
                    this.credentials_service.logout();
                    this.router.navigate(['./login/']);
                }
            );
        }
        return throwError(error);
    }

    intercept(
        req: HttpRequest<any>,
        next: HttpHandler
    ): Observable<HttpEvent<any>> {
        return next.handle(req).pipe(catchError(this.handleError.bind(this)));
    }
}
